import { render, staticRenderFns } from "./PaymentTile.vue?vue&type=template&id=19178c26"
import script from "./PaymentTile.vue?vue&type=script&lang=js"
export * from "./PaymentTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports